// extracted by mini-css-extract-plugin
export default {"home":"Home_home__INyQj","logo":"Home_logo__f0Ka9","form":"Home_form__iOxBl","acertou":"Home_acertou__Yensi","downUp":"Home_downUp__PObFl"};